import { createContext } from 'react';

import { ECommercePayload } from '../../types/trackingTypes';

export interface ITrackingContext {
  gtmEvent: (data: ECommercePayload) => void;
}

const TrackingContext = createContext<ITrackingContext>({
  gtmEvent: () => null,
});

export { TrackingContext };
